module.exports = __webpack_public_path__ + "assets/img/00001.49bbda52.png";